import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ModalFormContainerComponent } from '../../../../../../components/ui/modal-form-container/modal-form-container.component';
import { LocalCsvService } from '../../../../../../services/local-csv/local-csv.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { formatCount } from '../../../../../../../utils/sms';

@Component({
  selector: 'message-selected-csv-results',
  standalone: true,
  imports: [ModalFormContainerComponent, MatTooltipModule],
  templateUrl: './message-selected-csv-results.component.html',
  styleUrls: ['./message-selected-csv-results.component.css', '../selected-list.css'],
})
export class MessageSelectedCsvResultsComponent {
  localCSVService = inject(LocalCsvService);

  @Input() open: boolean = false;
  @Output() close = new EventEmitter();

  formatCount = formatCount;

  closeModal() {
    this.close.emit();
  }
}
